export default __webpack_public_path__ + "static/media/470c244197f87014879a6b9b22e7c27b.svg";